import { ListResult } from '@shared/api';
import { Api } from '../../Api';
import { IVerificationResultDto } from './interfaces';
import { IVerificationAccountGetQuery } from './query';

export class VerificationResult {
    private static _basePath = '/VerificationResult';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${VerificationResult._basePath}`;
        return {
            async get(query: IVerificationAccountGetQuery) {
                const path = '/';
                return await Api.get<ListResult<IVerificationResultDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
        };
    }
}
